import './google.login-system.less';
import AbstractLoginSystem from '../abstract-login-system';
import AbstractLoginSystemController from '../abstract-login-system-controller';
import type {IWindowService} from 'angular';
import type WalkerService from '../../../../commons/services/walker.service';
import type {Auth} from 'typings/portaro.be.types';

export class GoogleLoginSystemComponentController extends AbstractLoginSystemController {

    /*@ngInject*/
    constructor(private $window: IWindowService, private walker: WalkerService, private currentAuth: Auth, private CONTEXT_PATH: string) {
        super();
    }

    public isAuthenticated(): boolean {
        return this.currentAuth.role.includes('ROLE_EXTERNALLY_AUTHENTICATED');
    }

    public redirect() {
        this.walker.newPageOnContext('/login/oauth2/code/google', {redirect: this.$window.location.href});
    }
}

// eslint-disable-next-line
export default class GoogleLoginSystemComponent extends AbstractLoginSystem {
    public static componentName = 'google.loginSystem';

    public templateUrl = require('./google.login-system.tpl.ftl');

    public controller = GoogleLoginSystemComponentController;
}
